import { TMenhirInsurancePaymentMethod } from '@/common/integrations/menhir/employee/insurance/insurance.types';

export const DEFAULT_HOLDER_PAYMENT_METHODS_ALLOWED = [
  'wallet',
  'payroll',
] satisfies TMenhirInsurancePaymentMethod[];
